import React from 'react';
import {_GPY} from '../../../env.js'
import GpyToggleButton from './GpyToggleButton.js';

class ScoreboardSetupSingleSelect extends  React.Component {

	constructor(props) {
		super(props);
		this.state = {
	 	};
	}

	componentDidMount() {
		if(this.props.default!==undefined) {
			if(this.props.scoreboard.getComponent(this.props.scoreboard.getName()+"_button_setup_"+this.props.name+"_"+this.props.default)!==undefined) {
				this.props.scoreboard.getComponent(this.props.scoreboard.getName()+"_button_setup_"+this.props.name+"_"+this.props.default).onActivate(this.props.default);
			}
		}
   if(this.props.scoreboard !== undefined  && this.props.stateName!==undefined){
	       this.props.scoreboard.registerComponent(this.props.stateName,this);
	 };
	}

	deselectAll(){
		const my = this.props.scoreboard;
		this.props.items.map((item)=>{
			if(my.state.components[my.getName()+"_button_setup_"+this.props.name+"_"+item] !== undefined && my.state.components[my.getName()+"_button_setup_"+this.props.name+"_"+item].isActive()) {
				my.state.components[my.getName()+"_button_setup_"+this.props.name+"_"+item].onDeactivate();
			}
		});
	}

  render () {
		const my = this.props.scoreboard;
    return (
			<>
			<div className="row">
					<div className="col-12 p-1"><strong>{_GPY.i18n.get('gametype_'+my.getName()+'_scoreboard_setup_'+this.props.name+'_title')}</strong></div>
					{this.props.items.map((p)=>{
							return (
								<div key={p} className={"col-"+(this.props.col!==undefined ? this.props.col:"3")+" p-"+(this.props.p!==undefined ? this.props.p:"1")}>
								<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_setup_'+this.props.name+'_'+p+'_title')}
								onDeactivate={() => {
										this.props.onChange(undefined);
										return {visible: false};
									}
								}
								onActivate={() => {
										this.props.items.map((item)=>{
											if( p !== item && my.state.components[my.getName()+"_button_setup_"+this.props.name+"_"+item] !== undefined && my.state.components[my.getName()+"_button_setup_"+this.props.name+"_"+item].isActive()) {
												my.state.components[my.getName()+"_button_setup_"+this.props.name+"_"+item].onDeactivate();
											}
										});
										this.props.onChange(p);
										return {visible: true};
									}
								}
								scoreboard={this.props.scoreboard}
								getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
								stateName={this.props.scoreboard.getName()+"_button_setup_"+this.props.name+"_"+p}
								/>
							</div>
						);
					})}
			</div>
		 </>
		);
  }
}
export default ScoreboardSetupSingleSelect;
